import { render, staticRenderFns } from "./Jdqs2.vue?vue&type=template&id=f93e8b4c&scoped=true&"
import script from "./Jdqs2.vue?vue&type=script&lang=js&"
export * from "./Jdqs2.vue?vue&type=script&lang=js&"
import style0 from "./Jdqs2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Jdqs2.vue?vue&type=style&index=1&id=f93e8b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93e8b4c",
  null
  
)

export default component.exports